import { render } from "./MR_meteorologicalData.vue?vue&type=template&id=223ff422&scoped=true"
import script from "./MR_meteorologicalData.vue?vue&type=script&lang=js"
export * from "./MR_meteorologicalData.vue?vue&type=script&lang=js"

import "./MR_meteorologicalData.vue?vue&type=style&index=0&id=223ff422&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223ff422"]])

export default __exports__